<div class="col-12">
  <div class="header-image">
    <img src="/assets/layout/images/settings/integrations/connection-succeded.svg" alt="Successful connection" />
  </div>

  <h1>{{ _storeName }} <br /><small>is now enabled to</small> TAKU Retail</h1>
</div>
